"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = DataCaveats;

var _react = _interopRequireDefault(require("react"));

var _DownloadButton = _interopRequireDefault(require("./CampaignCreator/FindPersonas/DownloadButton"));

var _useFeatureAccessHook = require("../helpers/useFeatureAccessHook");

var _reactRedux = require("react-redux");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function DataCaveats(_ref) {
  var showDownload = _ref.showDownload;
  var isDataPage = (0, _reactRedux.useSelector)(function (state) {
    return state.options.isDataPage.value;
  });
  var dataMessage = (0, _reactRedux.useSelector)(function (state) {
    return state.options.dataMessage.value;
  });
  var dataDownloadPermission = (0, _reactRedux.useSelector)(function (state) {
    return state.options.permissions.dataDownload;
  });
  var hasDataDownload = (0, _useFeatureAccessHook.useFeatureAccess)(dataDownloadPermission);
  var innerHTML = {
    __html: dataMessage
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "fine-print"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    dangerouslySetInnerHTML: innerHTML
  }), isDataPage && hasDataDownload && showDownload && /*#__PURE__*/_react["default"].createElement(_DownloadButton["default"], null));
}